export class ListRoundsDTO {

    years!: any[]

}